import React from 'react';
import { AlertCircle, Check, X } from 'lucide-react';

export function SettingsFeedback({ feedback, onDismiss }) {
  if (!feedback.message) return null;
  const isSuccess = feedback.type === 'success';
  return (
    <div
      className={`callout ${isSuccess ? 'green' : 'red'}`}
      style={{ marginBottom: 16 }}
    >
      {isSuccess ? (
        <Check className="w-4 h-4" style={{ color: 'var(--color-green-500)', flexShrink: 0, marginTop: 1 }} />
      ) : (
        <AlertCircle className="w-4 h-4" style={{ color: 'var(--color-red-500)', flexShrink: 0, marginTop: 1 }} />
      )}
      <div className="callout-body" style={{ fontSize: 12.5 }}>
        {feedback.message}
      </div>
      <button
        onClick={onDismiss}
        className="icon-btn xs"
        aria-label="Dismiss"
        style={{ marginLeft: 'auto' }}
      >
        <X className="w-3 h-3" />
      </button>
    </div>
  );
}
